var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.0004 4.00023H4.00037C3.46993 4.00023 2.96123 4.21094 2.58615 4.58601C2.21108 4.96109 2.00037 5.46979 2.00037 6.00023V20.0002C2.00037 20.5307 2.21108 21.0394 2.58615 21.4144C2.96123 21.7895 3.46993 22.0002 4.00037 22.0002H18.0004C18.5308 22.0002 19.0395 21.7895 19.4146 21.4144C19.7897 21.0394 20.0004 20.5307 20.0004 20.0002V13.0002M18.5004 2.50023C18.8982 2.1024 19.4378 1.87891 20.0004 1.87891C20.563 1.87891 21.1025 2.1024 21.5004 2.50023C21.8982 2.89805 22.1217 3.43762 22.1217 4.00023C22.1217 4.56284 21.8982 5.1024 21.5004 5.50023L12.0004 15.0002L8.00037 16.0002L9.00037 12.0002L18.5004 2.50023Z",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.957d745ad9727009122d0828dd64782a.svg";
export { ForwardRef as ReactComponent };